import { render, staticRenderFns } from "./Mytestpaper.vue?vue&type=template&id=13a2d80a"
import script from "./Mytestpaper.vue?vue&type=script&lang=js"
export * from "./Mytestpaper.vue?vue&type=script&lang=js"
import style0 from "./Mytestpaper.vue?vue&type=style&index=0&id=13a2d80a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports